import { useMutation, useQueryClient } from "@tanstack/react-query";

import { profileApi } from "@/features/profile/services/profile.api";

export function useUpdateNotificationSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: profileApi.updateNotificationSettings,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["profile", "me"] });
    },
  });
}
